<div class="no-account-container">
  <h1>Welcome to WIRE</h1>
  <p>You have not been assigned to any sites yet. You may request access from your administrator for a specific
    site.</p>
  <button mat-raised-button color="primary" (click)="signOut()">Sign out / Try a different account</button>
</div>
